import { useEffect, useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
// material
import {
  Autocomplete,
  Grid,
  TextField,
  Menu,
  MenuItem,
  IconButton,Box,FormControl, InputLabel, Select,
  ListItemIcon,
  Stack,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";


// component
import Iconify from "../../../components/Iconify";
import {
  updateUserDataFc,
  updateUserDataFcDelete,
} from "src/api/faceRegistration";

import { registerFaceUpdate } from "src/api/faceRegistration";
// ----------------------------------------------------------------------
import WarningIcon from "@mui/icons-material/Warning";

export default function UserMoreMenu({ rowData, handleDetailsReload }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDelete, setOpenDelete] = useState(false); // State to manage dialog visibility

  const [openEntryIP, setOpenEntryIp] = useState(false); // State to manage dialog visibility

  const [openTerminate, setOpenTerminate] = useState(false); // State to manage dialog visibility

  const [name, setName] = useState(rowData.Name ? rowData.Name : "");
  const [contractorName, setContractorName] = useState(rowData.ContractorName ? rowData.ContractorName : "");
  const [departmentName, setDepartmentName] = useState(rowData.DepartmentName ? rowData.DepartmentName : "");



  const [ipAddress, setIpAddress] = useState("");
  
  const [errorMessage, setErrorMessage] = useState("");

  const handleIpAddress = (event) => {
    setIpAddress(event.target.value);
  };
  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  // const handleChangeContractorName = (event) => {
  //   setContractorName(event.target.value);
  // };

  // const handleChangeDepartmentName = (event) => {
  //   setDepartmentName(event.target.value);
  // };

  const handleEdit = () => {
    setIsOpen(false);
    setOpenDialog(true);
  };
  const handleSaveName = (name) => {
    // console.log("row", rowData, name);
    const updateData = {
      Id: rowData.Id,
      Name: name,
      ContractorName: contractorName,
      DepartmentName: departmentName
    };

    updateUserDataFc(updateData, (response) => {
      // console.log(response)
      if (response.status === 200) {
        // console.log("updated name");
        setOpenDialog(false);
        handleDetailsReload(true);
        // setShowMessage(true)
        // setFinalImage('')
        // setIsEdited(false)
        // setPrvValue('')
        // setEditNameError('')
        // setMobileError('')
        // setEditedPasswordError('')
        // getUserDetails((response)=>{
        //   if(response.status === 200){
        //     setUserDetails(response.data)
        //     setOpenDialogEdit(false)
        //   }
        // })
      }
    });
  };



  const handleGetIP = (ipAddress) => {
    // Updated regex to validate IP addresses correctly
    const validIP =
      /^(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})$/;

    if (validIP.test(ipAddress)) {
      // console.log("Valid IP Address:", ipAddress);

      const port = process.env.REACT_APP_PORT;
      // console.log("Port from .env:", port);

      const apiUrl = `http://${ipAddress}:${port}/`;
      // console.log("Calling API:", apiUrl);

      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {

            localStorage.setItem("netIP",ipAddress);
            setOpenEntryIp(false);
            // localStorage.setItem('DeleteURL',response)
            setOpenDelete(true);

            setErrorMessage(""); // Clear previous errors
            return response.json();
          } else {
            setErrorMessage(`Error: HTTP ${response.status}`);
            throw new Error(`HTTP Error: ${response.status}`);
          }
        })
        .then((data) => {
          // console.log("API Response:", data.live_url);
          // console.log("delete url",data.face_detection_base_url);
          localStorage.setItem("deleteURL",data.face_detection_base_url);


          // setStreamCamera(data.live_url);
          // setBaseURL(data.face_detection_base_url);
        })
        .catch((error) => {
          console.error("API Error:", error);
          setErrorMessage(
            "Please enter a valid IP address or check network connection."
          );
        });
    } else {
      console.error("Invalid IP Address:", ipAddress);
      setErrorMessage("Invalid IP format. Please enter a valid IPv4 address.");
    }
  };

  const handleDelete = () => {
    setIsOpen(false);
    const ipAddress = localStorage.getItem('netIP')
    if(ipAddress){
      handleGetIP(ipAddress)
      setOpenDelete(true);
    }
    else{
      setOpenEntryIp(true);
    }
  };

  const handleDeleteConfirm = () => {

    const body = {
      client_id: rowData.ClientId,
      user_id: rowData.Id,
    };
    updateUserDataFcDelete(body, (response) => {
      if (response.status === 200) {
        // console.log("updated name");
        
        setOpenDelete(false);
        handleDetailsReload(true);
      }
    });

    const updateData = {
      Id: rowData.Id,
      Name: name,
      Status: 2,
    };

    updateUserDataFc(updateData, (response) => {
      if (response.status === 200) {
        // console.log("updated name");
        registerFaceUpdate((result) => {
            if (result?.status === 200) {
                console.log("Face update success:", result.data);
            } else {
                console.error("Face update failed:", result);
            }
        });
        setOpenDelete(false);
        handleDetailsReload(true);
      }
    });


  };

  

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setOpenDelete(false);
    setOpenTerminate(false);
    setOpenEntryIp(false);
    // setOpenError(false)
  };

  const handleTerminate = () => {
    setIsOpen(false);
    setOpenTerminate(true);
  };

  const handleTerminateConfirm = () => {
    const updateData = {
      Id: rowData.Id,
      Name: name,
      Status: 0,
    };

    updateUserDataFc(updateData, (response) => {
      if (response.status === 200) {
        // console.log("updated name");
        setOpenTerminate(false);
        handleDetailsReload(true);
        registerFaceUpdate((result) => {
            if (result?.status === 200) {
                console.log("Face update success:", result.data);
            } else {
                console.error("Face update failed:", result);
            }
        });
      }
    });
  };


  const contractors = [
    "Alfia",
    "Supreme",
    "FF Services",
    "LMC Force Group",
    "NAPS"
]

  const departments = [
  "Sheeting Production",
  "IGD Production",
  "Maintenance",
  "Stores",
  "IGD Packing",
  "Sheeting Packing",
  "Graphite Production",
  "Gland Packing Production",
  "Housekeeping",
  "PTFE Production",
  "Purchase",
  "Admin"
];



const contractors1 = [
  "S.R.T.",
  "Shubham Enterprises",
  "Rohan 1",
  "Rohan 2",
  "Elite Enterprises",
  "F.F.S",
  "Shree Ganesh Enterprises",
  "LMC Force Group",
  "Sadguru Engineering"
];

const departments1 = [
    "Production",
    "Maintenance",
    "Stores",
    "Fabrication",
    "Housekeeping",
    "Admin",
    "Quality"
]


  const contractorList = (rowData.LocationId === 1 ? contractors : contractors1);
  const departmentList = (rowData.LocationId === 1 ? departments : departments1);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          component={RouterLink}
          to="#"
          sx={{ color: "text.secondary" }}
          onClick={handleEdit}
        >
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Edit"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>

        <MenuItem sx={{ color: "text.secondary" }} onClick={handleTerminate}>
          <ListItemIcon>
            <Iconify icon="mdi:cancel" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Terminate"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>

        <MenuItem sx={{ color: "text.secondary" }} onClick={handleDelete}>
          <ListItemIcon>
            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Delete"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
      </Menu>

<Dialog open={openDialog} fullWidth maxWidth="sm">
  <DialogTitle>Edit Name</DialogTitle>

  <DialogContent>
    <Box sx={{ mt: 2 }}>
      <Stack spacing={2}>
        <TextField
          fullWidth
          variant="outlined"
          label="Name"
          value={name}
          onChange={handleChangeName}
        />
        {/* <TextField
          fullWidth
          variant="outlined"
          label="Contractor"
          value={contractorName}
          onChange={handleChangeContractorName}
        />
        <TextField
          fullWidth
          variant="outlined"
          label="Department"
          value={departmentName}
          onChange={handleChangeDepartmentName}
        /> */}


                            <FormControl fullWidth sx={{ minWidth: 0, marginTop: 2 }}>
                              <InputLabel id="contractor-label">
                                Contractor
                              </InputLabel>
                              <Select
                                labelId="contractor-label"
                                value={contractorName}
                                label="Contractor Name"
                                onChange={(e) => setContractorName(e.target.value)}
                              >
                                {contractorList.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
        
                            <FormControl fullWidth sx={{ minWidth: 0, marginTop: 2 }}>
                              <InputLabel id="department-label">Department</InputLabel>
                              <Select
                                labelId="department-label"
                                value={departmentName}
                                label="Department"
                                onChange={(e) => setDepartmentName(e.target.value)}
                              >
                                {departmentList.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
      </Stack>
    </Box>
  </DialogContent>

  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button variant="outlined" color="error" onClick={handleCloseDialog}>
      Close
    </Button>
    <Button
      type="submit"
      onClick={() => handleSaveName(name)}
      variant="contained"
    >
      Save
    </Button>
  </DialogActions>
</Dialog>


      <Dialog open={openDelete}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <WarningIcon color="warning" sx={{ fontSize: 48 }} />
          <p>Are you sure you want to delete this Employee ?</p>
          {rowData.Name}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="contained">Cancel</Button>
          <Button
            onClick={() => {
              // Add delete logic here
              handleDeleteConfirm(); // Close the dialog after deletion
            }}
            color="error"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEntryIP} 
        PaperProps={{
          sx: { width: '500px', maxWidth: '90%' }, // Customize width here
        }}
      > 
        <DialogTitle>Enter Valid IP Address</DialogTitle>
        <DialogContent>
  <Stack
    direction="column"
    spacing={2}
    alignItems="center"
    justifyContent="center"
    sx={{ minHeight: '100px' }} // adjust height as needed
  >
    <TextField
      fullWidth
      variant="outlined"
      label="IP Address"
      value={ipAddress}
      onChange={handleIpAddress}
      error={Boolean(errorMessage)}
      helperText={errorMessage}
      sx={{ maxWidth: 400 }} // optional: limits max width of the field
    />
  </Stack>
</DialogContent>

        <DialogActions>
              <Button
                      type="submit"
                      onClick={() => handleCloseDialog()}
                      color="error"
                      variant="contained"
                      // disabled={disableGetButton} // Disable button when true
                    >
                      Close
                    </Button>

          <Button
                      type="submit"
                      onClick={() => handleGetIP(ipAddress)}
                      variant="contained"
                      // disabled={disableGetButton} // Disable button when true
                    >
                      Get
                    </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openTerminate}>
        <DialogTitle>Terminate Confirmation</DialogTitle>
        <DialogContent>
          <WarningIcon color="warning" sx={{ fontSize: 48 }} />
          <p>Are you sure you want to Terminate this Employee ?</p>
          {rowData.Name}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}  variant="contained">Cancel</Button>
          <Button
            onClick={() => {
              // Add delete logic here
              handleTerminateConfirm(); // Close the dialog after deletion
            }}
            color="error"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
